import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import CreateRenditionRequest from '../interfaces/ip-create-rendition';
import RenditionType from '../interfaces/ip-rendition-type';
import RenditionTypeCreation from '../interfaces/ip-rendition-type-creation';

@Injectable({
  providedIn: 'root'
})
export class IpRenditionService {
  private api = environment.api;

  constructor(private http: HttpClient) { }

  // RENDITION CREATION

  createRendition(rendition: CreateRenditionRequest) {
    return this.http.post(
      `${this.api}/invopay/renditions`,
      rendition
    );
  }

  uploadRenditionProofFile(file: File) {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post(
      `${this.api}/invopay/renditions/proofs/file`,
      formData,
      // If "responseType" is not set,
      // the server may respond with an invalid JSON,
      // making our subscriptions to catch it as an error,
      // even if it is an status 200 code.
      // (This is a backend issue that we are solving here)
      //{ responseType: 'arraybuffer' }
    );
  }

  // RENDITION TYPES

  getRenditionTypes(): Observable<RenditionType[]> {
    return this.http.get<RenditionType[]>(
      `${this.api}/invopay/rendition-types`
    );
  }

  createRenditionType(
    renditionType: RenditionTypeCreation
  ): Observable<RenditionType> {
    return this.http.post<RenditionType>(
      `${this.api}/invopay/rendition-types`,
      renditionType
    );
  }

  updateRenditionType(
    id: number,
    renditionType: RenditionTypeCreation
  ): Observable<RenditionType> {
    return this.http.put<RenditionType>(
      `${this.api}/invopay/rendition-types/${id}`,
      renditionType
    );
  }

  deleteRenditionType(id: number): Observable<Object> {
    return this.http.delete(
      `${this.api}/invopay/rendition-types/${id}`
    );
  }

  // OTHERS

  reportRendition(id: number) {
    return this.http.post(
      `${this.api}/invopay/renditions/report/${id}`,
      {}
    );
  }

  getRenditionProofDownloadLink(fileRef: string) {
    return this.http.get(
      `${this.api}/files/link`,
      {
        responseType: 'arraybuffer',
        params: {
          link: fileRef,
        },
      }
    );
  }
}
